enum DictionaryType {
    regions = 1,
    appointmentTypes = 2,
    specialities = 3,
    clinics = 4,
    doctors = 5,
}

export default DictionaryType;